import { render, staticRenderFns } from "./procurement_charts.vue?vue&type=template&id=6add60b4&"
import script from "./procurement_charts.vue?vue&type=script&lang=js&"
export * from "./procurement_charts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports